import { useCallback, useState } from 'react';

export type TableRow<T> = T & {
   action: 'delete' | 'add';
};

export function useTable<T>(initialRows: T[]) {
   const tableRows = initialRows
      .map((row: T): TableRow<T> => ({ ...row, action: 'delete' }))
      .concat([{ action: 'add' } as TableRow<T>]);

   const [data, setData] = useState(tableRows);

   const deleteRow = useCallback((idxToDelete: number) => {
      setData(oldData => oldData.filter((r, idx) => idx !== idxToDelete));
   }, []);

   const addRow = useCallback(() => {
      setData(oldData => {
         const lastRow = oldData.at(-1);
         if (lastRow) {
            lastRow.action = 'delete';
         }
         return oldData.concat([{ action: 'add' } as TableRow<T>]);
      });
   }, []);

   const editCell = useCallback((cell: any, newValue: string) => {
      setData(oldData =>
         oldData.map((r: any, idx: number) => {
            if (idx === cell.row.index) {
               return { ...r, [cell.column.id]: newValue };
            }
            return r;
         })
      );
   }, []);

   return { data, setData, deleteRow, addRow, editCell };
}
